import { useEffect } from "react";
import { Row, Card } from "antd";
import { useParams } from "react-router-dom";

import UserDetails from "./UserDetails";
import UserAnalytics from "./UserAnalytics";
import Statistics from "./Statistics";
import UsersPoints from "./UsersPoints";
import UserLessonRatings from "./UserLessonRatings";

const UserDetailsScreen = (props: any) => {
  const {
    analytics,
    analyticsLoading,
    actions: { getLearnerAnalytics },
  } = props;

  const { id } = useParams();

  useEffect(() => {
    window.scrollTo({ top: 0 });
    getLearnerAnalytics({ query: id });
  }, []);

  return (
    <Row className="h-full pb-[50px] flex flex-col">
      <div className="flex gap-7 mb-7">
        <Card className="shadow-md p-5  w-full h-[270px]">
          <UserDetails />
        </Card>
        <Card className="shadow-md p-5 w-full h-[270px]">
          <UserAnalytics
            title="Overall Progress"
            progress={analytics.progress}
            points={analytics.points}
            analyticsLoading={analyticsLoading}
          />
        </Card>
      </div>

      <div className="flex gap-7 mb-7">
        <Card className="shadow-md p-5 w-full">
          <Statistics />
        </Card>
        <Card className="shadow-md p-5 w-full">
          <UsersPoints />
        </Card>
      </div>

      <div className="flex gap-7 mb-7">
        <Card className="shadow-md p-5 pb-0 w-full">
          <UserAnalytics
            title="Module Progress"
            progress={analytics.moduleProgress}
            points={analytics.modulePoints}
            analyticsLoading={analyticsLoading}
          />
        </Card>
        <Card className="shadow-md p-5 pb-0 w-full">
          <UserAnalytics
            title="Course Progress"
            progress={analytics.courseProgress}
            points={analytics.coursePoints}
            analyticsLoading={analyticsLoading}
          />
        </Card>
      </div>

      <Card className="shadow-md p-5">
        <UserLessonRatings />
      </Card>
    </Row>
  );
};

export default UserDetailsScreen;
